import React from 'react';
import { motion, Variants } from 'framer-motion';
import './Features.css';
import { isSafariBrowser, scrollReveal, scrollRevealVariant } from '../utils/safariMotion';
import { useTranslation } from 'react-i18next';
import { useLandingNamespace } from '../context/LanguageLandingContext';

const Features: React.FC = () => {
  const safari = isSafariBrowser();
  const ns = useLandingNamespace();
  const { t } = useTranslation(ns);
  const features = [
    {
      id: 1,
      title: t('feature1Title'),
      description: t('feature1Description'),
      videoSrc:
        'https://ittechllc.s3.us-east-2.amazonaws.com/Substyle/Modify+Timing+Demo.webm',
    },
    {
      id: 2,
      title: t('feature2Title'),
      description: t('feature2Description'),
      videoSrc:
        'https://ittechllc.s3.us-east-2.amazonaws.com/Substyle/Color+Placement+Demo.webm',
    },
    {
      id: 3,
      title: t('feature3Title'),
      description: t('feature3Description'),
      videoSrc:
        'https://ittechllc.s3.us-east-2.amazonaws.com/Substyle/Copy+Demo.webm',
    },
  ];

  const featureVariants: Variants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeOut"
      }
    }
  };

  return (
    <section id="features" className="features">
      <div className="features-container">
        <motion.div 
          className="features-header"
          transition={{ duration: 0.8, ease: "easeOut" }}
          {...scrollReveal(safari, { opacity: 0, y: 30 }, { opacity: 1, y: 0 }, 'section')}
        >
          <motion.h2 
            className="features-title"
            transition={{ duration: 0.6, delay: 0.2 }}
            {...scrollReveal(safari, { opacity: 0, y: 20 }, { opacity: 1, y: 0 }, 'nested')}
          >
            {t('featuresTitle')}
          </motion.h2>
          <motion.p 
            className="features-subtitle"
            transition={{ duration: 0.6, delay: 0.4 }}
            {...scrollReveal(safari, { opacity: 0, y: 20 }, { opacity: 1, y: 0 }, 'nested')}
          >
            {t('featuresSubtitle')}
          </motion.p>
        </motion.div>
        
        <div className="features-list">
          {features.map((feature, index) => (
            <motion.div
              key={feature.id}
              className="feature-item"
              variants={featureVariants}
              {...scrollRevealVariant(safari, 'section')}
            >
              <div className="feature-content">
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-description">{feature.description}</p>
              </div>
              <motion.div 
                className="feature-video-container"
                transition={{ duration: 0.3 }}
              >
                <video 
                  className="feature-video"
                  autoPlay 
                  loop 
                  muted 
                  playsInline
                  controls={false}
                >
                  <source src={feature.videoSrc} type="video/webm" />
                  Your browser does not support the video tag.
                </video>
              </motion.div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
